import { render, staticRenderFns } from "./CategoryChildrenIds.vue?vue&type=template&id=4fadf790&"
import script from "./CategoryChildrenIds.vue?vue&type=script&lang=ts&"
export * from "./CategoryChildrenIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports